<template>
    <div class="tabs-wrap">
        <div class="tabs-bar">
            <div class="tab-item" @click="changeNav(item)" :class="{active: active == key(index)}"
                v-for="(item,index) in bar" :key="index">{{item.value}}</div>
        </div>
        <div class="tabs-body">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'tabs',
        model: {
            prop: 'active',
            event: 'change'
        },
        props: {
            active: {
                default: 0,
                type: Number | String
            },
            preClick: {
                type: Function,
                default: ()=>{}
            }
        },
        provide() {
            var self = this
            return {
                addBar(obj) {
                    self.conf[self.bar.length] = obj.keyword
                    self.bar.push(obj)
                },
                removeBar(id) {
                    let _index = self.bar.findIndex(v => v._id == id)
                    self.bar.splice(_index, 1)
                },
                setBar(obj) {
                    let _index = self.bar.findIndex(v => v._id == obj._id)
                    self.$set(self.bar, _index, obj)
                },
                active: () => self.active
            }
        },
        data: () => ({
            bar: [],
            conf: {}
        }),
        methods: {
            changeNav(item) {
                setTimeout(()=>{//等待一个事件循环因为setTimeout是事件循环里最后执行的，所以采用这个方法
                    if (this.preClick(item)) return
                    this.$emit('change', item.keyword)
                })
            },
            key(index) {
                // let conf = {
                //     0: 'renew',
                //     1: 'add',
                //     2: 'new'
                // }
                return this.conf[index]
            }
        }
    }
</script>

<style scoped>
    .tabs-bar {
        height: 39px;
        background:url(../assets/image/tiao.jpg) no-repeat left center rgb(10, 110, 224);
    }

    .tab-item {
        float: left;
        height: 39px;
        line-height: 39px;
        position: relative;
        width: 115px;
        text-align: center;
        font-size: 15px;
        color: white;
        border-top: 3px solid transparent;
        margin-top: -3px;
        cursor: default;
        position: relative;
        cursor: pointer;
    }

    .tab-item.active {
        background: rgb(188, 220, 245);
        color: rgb(2, 105, 226);
        border-top: 3px solid rgb(0, 95, 225);
    }
    .tab-item.active::after{
        content: '';
        position: absolute;
        border-top: 7px solid rgb(188, 220, 245);
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        bottom: -7px;
        left: 50%;
        margin-left: -7px;
        z-index: 1;
    }
    .tabs-body {
        background: rgb(247, 248, 250);
    }
</style>